import * as AuthActions from '../actions/user.actions';
import {AuthError} from '../models/auth-error';
import {createReducer, on} from '@ngrx/store';

export interface State {
    authError: AuthError;
    requestResetSuccessful: boolean;
}

export const initialState: State = {
    authError: null,
    requestResetSuccessful: false
};

export const reducer = createReducer(
    initialState,
    on(AuthActions.requestReset, state => ({...state, authError: null, requestResetSuccessful: false})),
    on(AuthActions.requestResetSuccess, state => ({...state, authError: null, requestResetSuccessful: true})),
    on(AuthActions.requestResetFailure, (state, {authError}) => ({...state, authError}))
);

export const getAuthError = (state: State) => state.authError;
export const getRequestResetSuccessful = (state: State) => state.requestResetSuccessful;
